import React from "react";
import { formatRate, StatCard } from "../../../ui";
import { useRateLimits } from "../../rate-limits/hooks/useRateLimits";

/**
 * Read-only "Limits" section folded into Usage & Billing (016 §4 — the standalone
 * /rate-limits page is removed). Paired label/value stat cards in a grid keep the
 * label next to its value (fixes review §4.3) and drop the card-in-card nesting.
 */
export function UsageLimitsSection() {
  const { rateLimits, isLoading } = useRateLimits();

  if (isLoading || !rateLimits) return null;

  return (
    <section className="mt-10">
      <h2 className="mb-4 text-xl font-semibold text-foreground">Limits</h2>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard
          title="Align Model"
          label="Requests"
          value={formatRate(rateLimits.align_rate_per_minute)}
        />
        <StatCard
          title="Align Lightning Model"
          label="Requests"
          value={formatRate(rateLimits.align_lightning_rate_per_minute)}
        />
        <StatCard
          title="Align Model (Tokens)"
          label="Tokens"
          value={formatRate(rateLimits.align_token_rate_per_minute)}
        />
        <StatCard
          title="Align Lightning Model (Tokens)"
          label="Tokens"
          value={formatRate(rateLimits.align_lightning_token_rate_per_minute)}
        />
      </div>
    </section>
  );
}
